import React from 'react'
import '../pages/writing.css'
import WriteCard from '../components/Writecard'
import data from '../data/write.json'
import { ReactDOM, useState} from 'react'

function WriteContainer() {
  const [items, setItems] = useState(data);

  return (
    <>
      <div className='cards'>
        {items.map((item,index) => (
          <WriteCard
            key={index}
            title={item.title}
            img={item.img}
            publication={item.publication}
            link={item.link}
          />
        ))}
      </div>
    </>
  )
}

export default WriteContainer